
import Vue from "vue";
import BaseButton from "@/components/buttons/BaseButton.vue";

export default Vue.extend({
  components: {BaseButton},
  props: {
    Headline:String,
    Content:String,
    ButtonConfirm:String,
  },
  data: function () {
    return {
      isActive: false,
    };
  },
  methods: {
    Show: function(){
      this.isActive = true;
    },
    Hide: function (){
      this.isActive = false;
    },
    Confirm: function (){
      this.Hide();
      this.$emit("confirmed");
    },
  },
});
